import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, Check, Star, Shield, Clock, HelpCircle, ChevronDown, ChevronUp, Zap } from 'lucide-react';
// Helper function to track Meta Pixel events
const trackPixelEvent = (eventName: string, params?: object) => {
  if (typeof (window as any).fbq === 'function') {
    ;
    (window as any).fbq('track', eventName, params);
  }
};
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-1 text-sm font-bold" data-id="element-120">
      <Clock className="w-4 h-4 text-[#d32f2f]" data-id="element-121" />
      <span className="text-[#d32f2f]" data-id="element-122">Precio especial termina en:</span>
      <span className="bg-[#d32f2f] text-white px-2 py-0.5 rounded font-mono" data-id="element-123">
        {pad(timeLeft.hours)}
      </span>
      <span className="text-[#d32f2f]" data-id="element-124">:</span>
      <span className="bg-[#d32f2f] text-white px-2 py-0.5 rounded font-mono" data-id="element-125">
        {pad(timeLeft.minutes)}
      </span>
      <span className="text-[#d32f2f]" data-id="element-126">:</span>
      <span className="bg-[#d32f2f] text-white px-2 py-0.5 rounded font-mono" data-id="element-127">
        {pad(timeLeft.seconds)}
      </span>
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-128">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-129">
        <span className="font-semibold text-[#1a1a1a] text-sm flex items-center gap-2" data-id="element-130">
          <HelpCircle className="w-4 h-4 text-[#4a7c2c] shrink-0" data-id="element-131" />
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-4 h-4 text-[#666] shrink-0" data-id="element-132" /> : <ChevronDown className="w-4 h-4 text-[#666] shrink-0" data-id="element-133" />}
      </button>
      {isOpen && <div className="px-4 pb-4 pt-0 text-sm text-[#666666] leading-relaxed" data-id="element-134">
          {answer}
        </div>}
    </div>;
}
export function PurchaseSection() {
  const handlePurchaseCombo1 = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Combo 1 - Guía para Hacer Esquejes',
      content_category: 'Guía Digital',
      value: 19990,
      currency: 'ARS'
    });
    window.location.href = 'https://checkout5.rosetadigital.com/cart/48571343143136:1';
  };
  const handlePurchaseCombo2 = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Combo 2 - Propagación Completa de Plantas',
      content_category: 'Guía Digital',
      value: 29990,
      currency: 'ARS'
    });
    window.location.href = 'https://checkout5.rosetadigital.com/cart/48571370438880:1';
  };
  const handlePurchaseCombo3 = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Combo 3 - Producción Comercial de Plantas',
      content_category: 'Guía Digital',
      value: 39990,
      currency: 'ARS'
    });
    window.location.href = 'https://checkout5.rosetadigital.com/cart/48571370635488:1';
  };
  return <section className="py-12 md:py-16 bg-[#fafaf9]" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-136">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-3" data-id="element-138">
            Elegí el combo que mejor se adapte a tu objetivo
          </h2>
          <p className="text-lg text-[#666666] mb-4" data-id="element-139">
            Todos los materiales son digitales y de acceso inmediato
          </p>
          <CountdownTimer data-id="element-140" />
        </div>

        {/* Guarantee Banner */}
        <div className="bg-[#e8f5e9] border-2 border-[#4a7c2c] rounded-2xl p-5 mb-8 max-w-3xl mx-auto" data-id="element-141">
          <div className="flex items-center gap-4" data-id="element-142">
            <div className="bg-[#4a7c2c] rounded-full p-3 shrink-0" data-id="element-143">
              <Shield className="w-8 h-8 text-white" data-id="element-144" />
            </div>
            <div data-id="element-145">
              <h3 className="font-bold text-[#2d5016] text-lg mb-1" data-id="element-146">
                Garantía total de satisfacción
              </h3>
              <p className="text-sm text-[#4a7c2c]" data-id="element-147">
                Si la guía no te sirve, te devolvemos el 100% de tu dinero. Sin
                preguntas, sin vueltas. Tenés 7 días para probarla sin riesgo.
              </p>
            </div>
          </div>
        </div>

        {/* Social Proof */}
        <div className="bg-white border border-[#e8f5e9] rounded-2xl p-6 mb-8 max-w-3xl mx-auto" data-id="element-148">
          <div className="flex items-center gap-4 mb-4" data-id="element-149">
            <div className="flex -space-x-2" data-id="element-150">
              <div className="w-10 h-10 rounded-full bg-[#4a7c2c] text-white flex items-center justify-center text-sm font-bold border-2 border-white" data-id="element-151">
                M
              </div>
              <div className="w-10 h-10 rounded-full bg-[#6b9d3e] text-white flex items-center justify-center text-sm font-bold border-2 border-white" data-id="element-152">
                C
              </div>
              <div className="w-10 h-10 rounded-full bg-[#8bc34a] text-white flex items-center justify-center text-sm font-bold border-2 border-white" data-id="element-153">
                L
              </div>
            </div>
            <p className="text-[#1a1a1a] font-medium" data-id="element-154">
              <span className="text-[#4a7c2c] font-bold" data-id="element-155">+1.578 personas</span>{' '}
              ya están multiplicando sus plantas con éxito
            </p>
          </div>
          <p className="text-sm text-[#666666] italic" data-id="element-156">
            "Antes perdía 8 de cada 10 esquejes. Ahora casi todos enraízan. La
            diferencia es tener un método claro." — Carla, Buenos Aires
          </p>
        </div>

        {/* Payment Security Badge */}
        <div className="text-center mb-6" data-id="element-157">
          <p className="text-sm text-[#666666] font-medium mb-2" data-id="element-158">
            Pago 100% seguro procesado por:
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/x9Mg8hPAKiR4fj4HHEEMJU/ML.jpg" alt="Mercado Libre - Pago Seguro" className="h-10 w-auto mx-auto" data-id="element-159" />
        </div>

        {/* Combos Grid */}
        <div className="grid md:grid-cols-3 gap-4 lg:gap-6 mb-8" data-id="element-160">
          {/* COMBO 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 overflow-hidden flex flex-col" data-id="element-161">
            <div className="bg-[#4a7c2c] text-white p-4 text-center" data-id="element-162">
              <h3 className="text-xl font-bold mb-1" data-id="element-163">COMBO 1</h3>
              <p className="text-base font-semibold mb-1" data-id="element-164">
                Guía para Hacer Esquejes
              </p>
              <p className="text-xs opacity-90" data-id="element-165">
                Todo lo que necesitás para empezar
              </p>
            </div>

            <div className="p-4 flex flex-col flex-1" data-id="element-166">
              <div className="mb-4 flex justify-center" data-id="element-167">
                <img src="https://cdn.magicpatterns.com/uploads/veKGvWWMpGDJWAzPky54mN/ChatGPT_Image_19_ene_2026,_03_20_12.png" alt="Guía Para Hacer Esquejes" className="w-3/4 h-auto rounded-lg shadow-md" data-id="element-168" />
              </div>

              <div className="space-y-2 mb-4" data-id="element-169">
                <div className="flex items-start gap-2" data-id="element-170">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-171" />
                  <span className="text-xs text-[#1a1a1a]" data-id="element-172">
                    Guía Completa para Hacer Esquejes
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-173">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-174" />
                  <span className="text-xs text-[#1a1a1a]" data-id="element-175">
                    5 Bonus exclusivos incluidos
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-176">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-177" />
                  <span className="text-xs text-[#1a1a1a]" data-id="element-178">
                    Entrega inmediata en PDF
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-179">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-180" />
                  <span className="text-xs text-[#1a1a1a]" data-id="element-181">
                    Acceso de por vida
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-182">
                  <Shield className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-183" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-184">
                    Garantía 7 días
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-185">
                <div className="text-center mb-3" data-id="element-186">
                  <p className="text-sm text-[#999] line-through" data-id="element-187">
                    $34.990 ARS
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-188">
                    <span className="text-3xl font-bold text-[#2d5016]" data-id="element-189">
                      $19.990
                    </span>
                    <span className="text-base font-bold text-[#4a7c2c]" data-id="element-190">
                      ARS
                    </span>
                  </div>
                  <p className="text-xs text-[#d32f2f] font-semibold mt-1" data-id="element-191">
                    🔥 Ahorrás $15.000
                  </p>
                </div>

                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} onClick={handlePurchaseCombo1} className="w-full bg-[#4a7c2c] text-white font-bold py-3.5 px-4 rounded-full shadow-lg hover:bg-[#3d6624] transition-colors flex items-center justify-center gap-2" data-id="element-192">
                  <ShoppingCart className="w-4 h-4" data-id="element-193" />
                  Comprar ahora - $19.990
                </motion.button>
                <p className="text-center text-xs text-[#999] mt-2" data-id="element-194">
                  ⚡ Recibís la guía en 2 minutos
                </p>
              </div>
            </div>
          </motion.div>

          {/* COMBO 2 - RECOMMENDED */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl shadow-2xl border-2 border-[#4a7c2c] overflow-hidden flex flex-col relative md:-mt-2 md:mb-[-8px]" data-id="element-195">
            <div className="absolute top-3 right-3 bg-[#fbbf24] text-[#1a1a1a] px-2 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow-lg z-10" data-id="element-196">
              <Star className="w-3 h-3 fill-current" data-id="element-197" />
              Más elegido
            </div>

            <div className="bg-[#2d5016] text-white p-4 text-center" data-id="element-198">
              <h3 className="text-xl font-bold mb-1" data-id="element-199">COMBO 2</h3>
              <p className="text-base font-semibold mb-1" data-id="element-200">
                Propagación Completa de Plantas
              </p>
              <p className="text-xs opacity-90" data-id="element-201">
                Ideal si querés profundizar en la propagación
              </p>
            </div>

            <div className="p-4 flex flex-col flex-1" data-id="element-202">
              <div className="mb-4" data-id="element-203">
                <img src="https://cdn.magicpatterns.com/uploads/ffJZeiPw7ZJZT5U4bDmMkG/Gula_practica_para_plantAs_sanas,_FUERTES_y_sin_venenos..png" alt="Fertilizantes y Plaguicidas Naturales Caseros" className="w-full h-auto rounded-lg shadow-md" data-id="element-204" />
              </div>

              <div className="space-y-2 mb-4" data-id="element-205">
                <div className="flex items-start gap-2" data-id="element-206">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-207" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-208">
                    Todo lo incluido en el Combo 1
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-209">
                  <Zap className="w-4 h-4 text-[#fbbf24] shrink-0 mt-0.5" data-id="element-210" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-211">
                    Manual: Fertilizantes y Plaguicidas Naturales
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-212">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-213" />
                  <span className="text-xs text-[#1a1a1a]" data-id="element-214">
                    Entrega inmediata en PDF
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-215">
                  <Shield className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-216" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-217">
                    Garantía 7 días
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-218">
                <div className="text-center mb-3" data-id="element-219">
                  <p className="text-sm text-[#999] line-through" data-id="element-220">
                    $54.990 ARS
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-221">
                    <span className="text-3xl font-bold text-[#2d5016]" data-id="element-222">
                      $29.990
                    </span>
                    <span className="text-base font-bold text-[#4a7c2c]" data-id="element-223">
                      ARS
                    </span>
                  </div>
                  <p className="text-xs text-[#d32f2f] font-semibold mt-1" data-id="element-224">
                    🔥 Ahorrás $25.000
                  </p>
                </div>

                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} onClick={handlePurchaseCombo2} className="w-full bg-[#2d5016] text-white font-bold py-3.5 px-4 rounded-full shadow-lg hover:bg-[#1a330a] transition-colors flex items-center justify-center gap-2" data-id="element-225">
                  <ShoppingCart className="w-4 h-4" data-id="element-226" />
                  Comprar ahora - $29.990
                </motion.button>
                <p className="text-center text-xs text-[#999] mt-2" data-id="element-227">
                  ⚡ Recibís la guía en 2 minutos
                </p>
              </div>
            </div>
          </motion.div>

          {/* COMBO 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-2xl shadow-lg border-2 border-gray-200 overflow-hidden flex flex-col" data-id="element-228">
            <div className="bg-[#6b9d3e] text-white p-4 text-center" data-id="element-229">
              <h3 className="text-xl font-bold mb-1" data-id="element-230">COMBO 3</h3>
              <p className="text-base font-semibold mb-1" data-id="element-231">
                Producción Comercial de Plantas
              </p>
              <p className="text-xs opacity-90" data-id="element-232">
                Empezá a vender tus propias plantas
              </p>
            </div>

            <div className="p-4 flex flex-col flex-1" data-id="element-233">
              <div className="mb-4" data-id="element-234">
                <img src="https://cdn.magicpatterns.com/uploads/adiwPphaDGshDTcc65KzCi/Guia_practica_para_plantas_sanas_fuertes_y_sin_venenos.png" alt="Organización y Producción de Plantas" className="w-full h-auto rounded-lg shadow-md" data-id="element-235" />
              </div>

              <div className="space-y-2 mb-4" data-id="element-236">
                <div className="flex items-start gap-2" data-id="element-237">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-238" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-239">
                    Todo lo incluido en Combo 1 y 2
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-240">
                  <Zap className="w-4 h-4 text-[#fbbf24] shrink-0 mt-0.5" data-id="element-241" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-242">
                    Manual: Organización y Producción Comercial
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-243">
                  <Check className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-244" />
                  <span className="text-xs text-[#1a1a1a]" data-id="element-245">
                    Entrega inmediata en PDF
                  </span>
                </div>
                <div className="flex items-start gap-2" data-id="element-246">
                  <Shield className="w-4 h-4 text-[#4a7c2c] shrink-0 mt-0.5" data-id="element-247" />
                  <span className="text-xs text-[#1a1a1a] font-medium" data-id="element-248">
                    Garantía 7 días
                  </span>
                </div>
              </div>

              <div className="mt-auto" data-id="element-249">
                <div className="text-center mb-3" data-id="element-250">
                  <p className="text-sm text-[#999] line-through" data-id="element-251">
                    $74.990 ARS
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-252">
                    <span className="text-3xl font-bold text-[#2d5016]" data-id="element-253">
                      $39.990
                    </span>
                    <span className="text-base font-bold text-[#4a7c2c]" data-id="element-254">
                      ARS
                    </span>
                  </div>
                  <p className="text-xs text-[#d32f2f] font-semibold mt-1" data-id="element-255">
                    🔥 Ahorrás $35.000
                  </p>
                </div>

                <motion.button whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} onClick={handlePurchaseCombo3} className="w-full bg-[#4a7c2c] text-white font-bold py-3.5 px-4 rounded-full shadow-lg hover:bg-[#3d6624] transition-colors flex items-center justify-center gap-2" data-id="element-256">
                  <ShoppingCart className="w-4 h-4" data-id="element-257" />
                  Comprar ahora - $39.990
                </motion.button>
                <p className="text-center text-xs text-[#999] mt-2" data-id="element-258">
                  ⚡ Recibís la guía en 2 minutos
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Payment Info */}
        <div className="max-w-2xl mx-auto mb-12" data-id="element-259">
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-4 mb-4" data-id="element-260">
            <div className="text-center mb-3" data-id="element-261">
              <p className="text-sm text-[#666666] font-medium mb-2" data-id="element-262">
                Pago 100% seguro procesado por:
              </p>
              <img src="https://cdn.magicpatterns.com/uploads/x9Mg8hPAKiR4fj4HHEEMJU/ML.jpg" alt="Mercado Libre - Pago Seguro" className="h-8 w-auto mx-auto" data-id="element-263" />
            </div>

            <div className="bg-[#e3f2fd] border border-[#90caf9] rounded-xl p-3" data-id="element-264">
              <p className="text-sm text-[#1a1a1a] leading-relaxed text-center" data-id="element-265">
                <span className="font-bold" data-id="element-266">💡 Importante:</span> Si no tenés
                cuenta en Mercado Pago, no te preocupes. Podés pagar con tarjeta
                de crédito o débito sin necesidad de tener cuenta. El pago es
                100% seguro.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Section - Objection Handling */}
        <div className="max-w-2xl mx-auto" data-id="element-267">
          <h3 className="text-2xl font-bold text-[#1a1a1a] text-center mb-6" data-id="element-268">
            Preguntas frecuentes
          </h3>
          <div className="space-y-3" data-id="element-269">
            <FAQItem question="¿Cómo recibo la guía después de pagar?" answer="Inmediatamente después de confirmar el pago, recibís un email con el link de descarga. En menos de 2 minutos tenés todo el material en tu celular o computadora. Es un PDF que podés leer en cualquier dispositivo." data-id="element-270" />
            <FAQItem question="¿Necesito tener cuenta en Mercado Pago?" answer="No, no necesitás cuenta. Usamos Mercado Pago como pasarela de pagos segura, pero podés pagar con cualquier tarjeta de crédito o débito sin registrarte. El proceso es rápido y seguro." data-id="element-271" />
            <FAQItem question="¿Funciona si nunca hice esquejes?" answer="¡Sí! La guía está pensada especialmente para principiantes. Empezás desde cero con pasos claros y simples. No necesitás experiencia previa ni conocimientos técnicos." data-id="element-272" />
            <FAQItem question="¿Qué pasa si no me sirve?" answer="Tenés 7 días de garantía total. Si la guía no cumple tus expectativas, te devolvemos el 100% de tu dinero sin hacerte ninguna pregunta. El riesgo es cero." data-id="element-273" />
            <FAQItem question="¿Por qué comprar esto si hay info gratis en internet?" answer="La info gratis está desordenada, es contradictoria y te hace perder tiempo (y plantas). Esta guía organiza todo en un método probado, paso a paso, pensado para nuestro clima. Ahorrás meses de prueba y error." data-id="element-274" />
            <FAQItem question="¿Sirve para cualquier tipo de planta?" answer="Sí, el método se aplica a la mayoría de plantas de interior y exterior. Además incluye una guía rápida con las especies más populares y un capítulo especial de suculentas." data-id="element-275" />
          </div>

          {/* Final CTA */}
          <div className="text-center mt-8" data-id="element-276">
            <p className="text-sm text-[#4a7c2c] font-medium" data-id="element-277">
              🛡️ Garantía de 7 días · 📱 Entrega inmediata · 🔒 Pago seguro
            </p>
          </div>
        </div>
      </div>
    </section>;
}